import { render, staticRenderFns } from "./word-filter-panel.vue?vue&type=template&id=6351eb82&"
import script from "./word-filter-panel.vue?vue&type=script&lang=js&"
export * from "./word-filter-panel.vue?vue&type=script&lang=js&"
import style0 from "./word-filter-panel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/alpheios-core/alpheios-core/packages/components/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6351eb82')) {
      api.createRecord('6351eb82', component.options)
    } else {
      api.reload('6351eb82', component.options)
    }
    module.hot.accept("./word-filter-panel.vue?vue&type=template&id=6351eb82&", function () {
      api.rerender('6351eb82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/word-list/word-filter-panel.vue"
export default component.exports